module.exports = __webpack_public_path__ + "static/img/ala.5d5a2f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ala.jpg
// module id = sLce
// module chunks = 1